export default __webpack_public_path__ + "static/media/work2image1.eb463299.png";